import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { OwnershipWizard } from "@/features/ownership/components/ownership-wizard"
import { countryQueries } from "@/queries/countries"
import { ownershipQueries } from "@/queries/ownership"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/ownership/edit/"
)({
  staticData: { attention: "firm.ownership" },
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(ownershipQueries.firm(params.firmId)),
      context.queryClient.ensureQueryData(countryQueries.list()),
    ])
  },
  component: RecordOwnershipPage,
})

function RecordOwnershipPage() {
  const { firmId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <OwnershipWizard
      firmId={firmId}
      onFinished={() =>
        void navigate({
          from: "/$organisation",
          to: "/$organisation/firms/$firmId/ownership",
          params: { firmId },
        })
      }
    />
  )
}
